"use strict";

exports.__esModule = true;
exports.createCellFormatter = createCellFormatter;
exports.createCellWrapper = createCellWrapper;
exports.format = format;
exports.formattableTypes = void 0;
exports.getCellValue = getCellValue;
exports.getEdges = getEdges;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Metrics = require("../../../Catalogs/Metrics");
var _Utils = require("../../../Utils");
var _Formatters = require("../../Widgets/DataTable/Formatters");
var _timestampFormatter = require("../../Widgets/DataTable/Formatters/timestampFormatter");
var _BarChartCell = require("./BarChartCell");
var _ChangeColumnIcon = require("./ChangeColumnIcon");
var _PgTrendLine = require("./PgTrendLine");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CellWrapperContainer = _styledComponents["default"].div.withConfig({
  displayName: "columnFormatters__CellWrapperContainer",
  componentId: "sc-1g8d31f-0"
})([":focus{border:none;outline:none;outline-offset:0;}"]);
var formattableTypes = exports.formattableTypes = ["date", "number", "string", "deviceName", "fractionalPercent", "duration", "workday", "state", "activity", "day", "month", "quarter", "year", "week", "status", "assignee", "creator", "ticketTypes", "ticketPriority", "devicesAndGroups", "age", "range", "lookUpForTypeInRow", "metric", "changeColumn", "trendline", "hour", "hour-day", "author", "boolean"];
function getEdges(column, data) {
  var min = Infinity;
  var max = -Infinity;
  data.forEach(function (value) {
    var val = (0, _path2["default"])(column.id.split("."), value);
    if (val < min) {
      min = val;
    }
    if (val > max) {
      max = val;
    }
  });
  return [min, max];
}
function format(_ref) {
  var column = _ref.column,
    translate = _ref.translate,
    time = _ref.time,
    devices = _ref.devices,
    plantStateActivities = _ref.plantStateActivities,
    row = _ref.row,
    users = _ref.users,
    ticketTypes = _ref.ticketTypes;
  if (column.type === "duration") {
    return (0, _Utils.formatDuration)(row.value);
  }
  return (0, _Formatters.createValueFormatter)({
    translate: translate,
    time: time,
    devices: devices,
    plantStateActivities: plantStateActivities,
    users: users,
    ticketTypes: ticketTypes
  })(column, row.value);
}
function getCellValue(column, row) {
  var _row$original, _row$original2, _row$original3;
  // eslint-disable-next-line no-nested-ternary
  var cellValue = row.value ? row.value : ((_row$original = row.original) == null ? void 0 : _row$original[column.id]) !== undefined ? row.original[column.id] : "-";

  // eslint-disable-next-line no-restricted-globals
  if ((_row$original2 = row.original) != null && _row$original2[column.id + ".type"] && ["fractionalPercent", "number", "duration"].includes((_row$original3 = row.original) == null ? void 0 : _row$original3[column.id + ".type"]) && isNaN(cellValue)) {
    return "0";
  }
  return cellValue;
}
function CellWrapper(_ref2) {
  var hasSubComponent = _ref2.hasSubComponent,
    row = _ref2.row,
    children = _ref2.children;
  if (hasSubComponent && row.columnProps) {
    return /*#__PURE__*/_react["default"].createElement(CellWrapperContainer, null, children);
  }
  return children;
}
function getFormattedValue(args, row, hideBarChart) {
  var column = args.column,
    translate = args.translate,
    time = args.time,
    devices = args.devices,
    plantStateActivities = args.plantStateActivities,
    data = args.data,
    devicesMap = args.devicesMap,
    statesMap = args.statesMap,
    activitiesMap = args.activitiesMap,
    users = args.users,
    ticketTypes = args.ticketTypes;
  var cellValue = getCellValue(column, row);
  var metricDefinitionsFastFind = _Metrics.metricDefinitions.reduce(function (acc, metric) {
    acc[metric.name] = metric.label;
    return acc;
  }, {});
  if (formattableTypes.includes(column.type)) {
    var columnType = column.type;
    if (columnType === "lookUpForTypeInRow") {
      var _row$original4;
      columnType = (row == null ? void 0 : row[column.id + ".type"]) || ((_row$original4 = row.original) == null ? void 0 : _row$original4[column.id + ".type"]);
    }
    var barChartScaleSource = column.barChartScaleSource,
      barChartMinValue = column.barChartMinValue,
      barChartMaxValue = column.barChartMaxValue;
    if (columnType === "changeColumn") {
      // $FlowIgnore
      return (0, _ChangeColumnIcon.changeColumnIcon)(cellValue);
    }
    if (columnType === "trendline") {
      var _row$original5, _row$original6;
      return /*#__PURE__*/_react["default"].createElement(_PgTrendLine.PgTrendLine, {
        width: row.width,
        color: (_row$original5 = row.original) == null ? void 0 : _row$original5.trendlineColor,
        rowValues: (_row$original6 = row.original) == null ? void 0 : _row$original6.valueArray
      });
    }
    if (column.showBarChart && hideBarChart !== true) {
      var _ref3 = barChartScaleSource === "auto" ? getEdges(column, data) : [(Number(barChartMinValue) || 0) * 1000, (Number(barChartMaxValue) || 100) * 1000],
        min = _ref3[0],
        max = _ref3[1];
      return /*#__PURE__*/_react["default"].createElement(_BarChartCell.BarChartCell, {
        label: format({
          column: column,
          translate: translate,
          time: time,
          devices: devices,
          plantStateActivities: plantStateActivities,
          row: row,
          users: users,
          ticketTypes: ticketTypes
        }),
        rawValue: cellValue,
        colProps: Object.assign({}, column, {
          barChartMinValue: min,
          barChartMaxValue: max
        })
      });
    }
    if (columnType === "deviceName") {
      return devicesMap[cellValue] || "";
    }
    if (columnType === "state") {
      return statesMap[cellValue] || "";
    }
    if (columnType === "activity") {
      return activitiesMap[cellValue] || "";
    }
    if (columnType === "age") {
      var parsedCellValue = parseInt(cellValue, 10);
      // eslint-disable-next-line no-restricted-globals
      return isNaN(parsedCellValue) ? "-" : Math.ceil(parsedCellValue / _timeDefinitions.DAY_IN_MILLIS) + "d";
    }
    if (columnType === "metric") {
      return metricDefinitionsFastFind[cellValue] || cellValue;
    }
    if (columnType === "range") {
      var rowVal = cellValue || "";
      return rowVal.split("-").map(function (milli) {
        var parsedMillis = parseInt(parseFloat(milli).toFixed(), 10);
        var formatted = (0, _Utils.formatDuration)(parsedMillis);
        return formatted === "NaNs" ? "∞" : formatted;
      }).join(" - ");
    }
    if (columnType === "hour") {
      return Number(cellValue) >= 0 && Number(cellValue) < 10 ? "0" + cellValue + ":00" : cellValue + ":00";
    }
    if (columnType === "hour-day") {
      return (0, _timestampFormatter.getHourByDay)(cellValue);
    }
    if (columnType === "boolean") {
      return cellValue === true ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translate("yes", "Yes"), " ", /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.TICK
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translate("no", "No"), " ", /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: _icons.IconNames.CROSS
      }));
    }
    return format({
      column: Object.assign({}, column, {
        type: columnType
      }),
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      row: Object.assign({}, row, {
        value: cellValue
      }),
      users: users,
      ticketTypes: ticketTypes
    });
  }
  return cellValue;
}
function createCellFormatter(args) {
  return function (row, hideBarChart) {
    return getFormattedValue(args, row, hideBarChart);
  };
}
function createCellWrapper(args) {
  var hasSubComponent = args.hasSubComponent;
  return function (row, hideBarChart) {
    return /*#__PURE__*/_react["default"].createElement(CellWrapper, {
      hasSubComponent: hasSubComponent,
      row: row
    }, /*#__PURE__*/_react["default"].createElement("span", null, getFormattedValue(args, row, hideBarChart)));
  };
}